
import { HandToolBehavior } from '../../packages/hand/HandToolBehavior';
import { PingToolBehavior } from '../../packages/presentation/PingTool';
import { ContextMenuToolBehavior } from '../contextMenu/ContextMenuToolBehavior';
import { CommonShortcutToolBehavior } from './CommonShortcutToolBehavior';
import { DebugToolBehavior } from './DebugToolBehavior';
import { HyperlinkToolBehavior } from './HyperlinkToolBehavior';
import { InteractionToolBehavior } from './InteractionToolBehavior';
import { PanZoomToolBehavior } from './PanZoomToolBehavior';
import { QuickCreateToolBehavior } from './QuickCreateToolBehavior';
import { RepeatToolBehavior } from './RepeatToolBehavior';
import { SelectionToolBehavior } from './SelectionToolBehavior';
import { ShowObjectToolBehavior } from './ShowObjectToolBehavior';
import { SlapToolBehavior } from './SlapToolBehavior';
import { ToolboxItem } from './ToolboxItem';
import { defineTool, ToolDefinition } from './ToolDefinition';
import { TransformToolBehavior } from './TransformToolBehavior';

export const defineToolWithCommonBehaviors = (def: ToolDefinition) => {
    const { behaviors, ...props } = def;
    return Object.assign(props, {
        behaviors: [
            RepeatToolBehavior,
            CommonShortcutToolBehavior,
            PingToolBehavior,
            ...behaviors,
            PanZoomToolBehavior(),
            SlapToolBehavior,
        ]
    });
};

export const debugTool = defineToolWithCommonBehaviors({
    id: 'debugTool',
    label: 'Debug Tool',
    category: 'debug',
    behaviors: [
        DebugToolBehavior,
    ]
});

export const defaultTool = defineTool({
    id: 'pointerTool',
    label: 'Pointer',
    category: 'core',
    icon: 'deqo://icons/d2/cursor',
    weight: 100,
    behaviors: [
        HandToolBehavior,
        HyperlinkToolBehavior,
        // RepeatToolBehavior,
        CommonShortcutToolBehavior,
        PingToolBehavior,
        InteractionToolBehavior,
        QuickCreateToolBehavior,
        SelectionToolBehavior,
        TransformToolBehavior,
        PanZoomToolBehavior(),
        SlapToolBehavior,
        ShowObjectToolBehavior,
        ContextMenuToolBehavior,
    ]
});

export const pointerToolboxItem = ToolboxItem({
    id: 'pointerTool',
    label: 'Pointer',
    weight: 100,
    tools: [defaultTool],
});

export const handTool = defineTool({
    id: 'handTool',
    label: 'Hand Tool',
    category: 'core',
    weight: 100,
    behaviors: [
        CommonShortcutToolBehavior,
        PingToolBehavior,
        PanZoomToolBehavior({ hasPriority: true }),
    ]
});
